import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiPower } from 'react-icons/fi';

import { Container, Links, MobileMenu, MobileMenuIcon } from './styles';

import MenuButton from './MenuButton';
import DropdownContent from './DropdownContent';

import logoImg from '../../assets/logo.svg';
import logoMobileImg from '../../assets/logo-mobile.svg';

import { useAuth } from '../../hooks/auth';

const Toolbar: React.FC = () => {
  const { signOut } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <Container>
      <img src={logoImg} alt="MyFinances" className="desktop" />
      <img src={logoMobileImg} alt="MyFinances" className="mobile" />

      <Links>
        <Link to="/dashboard" id="dashboard">
          Dashboard
        </Link>

        <Link to="/transactions-summary" id="transactions">
          Transações
        </Link>

        <Link to="/accounts" id="accounts">
          Contas
        </Link>

        <Link to="/account-manager" id="weights">
          Pesos
        </Link>

        <Link to="/analytics" id="analytics">
          Analytics
        </Link>

        <MenuButton title="Investimentos">
          <DropdownContent>
            <Link to="portfolio-v2">Carteira</Link>
            <Link to="portfolio-distribution-v2">Distribuição de ativos</Link>
            <Link to="portfolio-allocation-v2">Alocação de ativos</Link>
          </DropdownContent>
        </MenuButton>

        <button
          id="signout"
          type="button"
          onClick={signOut}
          className="desktop"
        >
          <FiPower size={24} />
        </button>

        {/* Hamburger menu icon for mobile */}
        <MobileMenuIcon onClick={toggleMobileMenu}>&#9776;</MobileMenuIcon>

        {/* Mobile menu content */}
        {mobileMenuOpen && (
          <MobileMenu>
            <Link to="/dashboard">Dashboard</Link>
            <Link to="transactions-summary">Transações</Link>
            <Link to="account-manager">Pesos</Link>
            <Link to="/accounts">Contas</Link>
            <Link to="/analytics">Analytics</Link>
            <Link to="/portfolio">Carteira de investimentos</Link>
            <Link to="/portfolio-distribution">Distribuição de ativos</Link>
            <button type="button" onClick={signOut}>
              <FiPower size={24} />
            </button>
          </MobileMenu>
        )}
      </Links>
    </Container>
  );
};

export default Toolbar;
